__turbopack_context__.v({
  "buttonLabelPrefix": "FilterSort-module-scss-module__vcBYMq__buttonLabelPrefix",
  "buttonLabelValue": "FilterSort-module-scss-module__vcBYMq__buttonLabelValue",
  "fade-in": "FilterSort-module-scss-module__vcBYMq__fade-in",
  "label": "FilterSort-module-scss-module__vcBYMq__label",
  "no-transform": "FilterSort-module-scss-module__vcBYMq__no-transform",
  "rotate": "FilterSort-module-scss-module__vcBYMq__rotate",
});
